module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('van-cell-group', [_c('van-field', {
    attrs: {
      "label": "用户名",
      "placeholder": "请输入姓名",
      "input-align": "right",
      "error": _vm.formValidate && !_vm.formData.name
    },
    model: {
      value: (_vm.formData.name),
      callback: function($$v) {
        _vm.$set(_vm.formData, "name", $$v)
      },
      expression: "formData.name"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [(!_vm.loading) ? _c('van-button', {
    attrs: {
      "type": "danger",
      "round": "",
      "size": "large"
    },
    on: {
      "click": _vm.formSave
    }
  }, [_vm._v("确定")]) : _c('van-button', {
    attrs: {
      "type": "danger",
      "round": "",
      "size": "large"
    }
  }, [_vm._v("确定中...")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7ce4ad8c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/mine/setting/Username.vue
// module id = 2512
// module chunks = 0